export default __webpack_public_path__ + "static/media/2DE20D07-6ADD-4CC2-B959-33BD83481BA7_1_105_c.9c064c81.jpeg";